import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edex-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss']
})
export class SecurityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
